import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import ReactDOM from 'react-dom';
import { SaferGamblingModalsInterface } from '@central-products/interface-safer-gambling-modals';
import SaferGamblingModals from './components/SaferGamblingModals';

var SaferGamblingModalsFeature = function (_SaferGamblingModalsI) {
  _inherits(SaferGamblingModalsFeature, _SaferGamblingModalsI);

  function SaferGamblingModalsFeature(config) {
    _classCallCheck(this, SaferGamblingModalsFeature);

    var _this = _possibleConstructorReturn(this, (SaferGamblingModalsFeature.__proto__ || _Object$getPrototypeOf(SaferGamblingModalsFeature)).call(this));

    _this.isStarted = false;

    _this.translations = config.translations;
    return _this;
  }

  _createClass(SaferGamblingModalsFeature, [{
    key: 'start',
    value: function start() {
      if (this.isStarted) {
        return;
      }

      var domNode = document.createElement('div');
      document.body.appendChild(domNode);

      ReactDOM.render(React.createElement(SaferGamblingModals, { translations: this.translations }), domNode);
      this.isStarted = true;
    }
  }]);

  return SaferGamblingModalsFeature;
}(SaferGamblingModalsInterface);

export default SaferGamblingModalsFeature;